// @flow
import React from 'react';
import { red900, green300, orange300 } from 'material-ui/styles/colors';

type Props = {
  value: ?string,
};

const UserStatus = ({ value }: Props) => {
  switch (value) {
    case 'UserStatus.Active':
      return <span style={{ color: green300 }}>Active</span>;
    case 'UserStatus.Pending':
      return <span style={{ color: orange300 }}>Pending</span>;
    case 'UserStatus.Locked':
      return <span style={{ color: red900 }}>Locked</span>;
    default:
      return null;
  }
};

export default UserStatus;



// WEBPACK FOOTER //
// ./src/modules/components/UserStatus.js